export default __webpack_public_path__ + "static/biking-c41077b08c04ba3ba9a7f996c4c31c32.mp4";